import { useState } from 'react';

import { ToggleButton, ToggleButtonGroup } from '../shared/ToggleButton';
import { ActivationsView } from './ActivationsView';
import { EventsView } from './EventsView';
import { ScheduleView } from './ScheduleView';
import { Loading, Section } from '../shared';

import { useEvents } from '../hooks/events';

import styles from './Events.module.scss';

type View = 'schedule' | 'activations' | 'events';

export function Events() {
    const { isLoading, isError } = useEvents();
    const [view, setView] = useState<View>('schedule');
    const [initialEventId, setInitialEventId] = useState('');

    if (isLoading) {
        return <Loading />;
    }

    return (
        <Section className={styles.container}>
            <header className={styles.header}>
                <h1>Events</h1>
                <p>
                    Plan activation windows using start and end dates, then
                    publish by event.
                </p>
            </header>

            <div className={styles.navigation}>
                <ToggleButtonGroup
                    color="primary"
                    value={view}
                    onToggle={(nextView) => setView(nextView as View)}
                >
                    <ToggleButton value="schedule">Schedule</ToggleButton>
                    <ToggleButton value="activations">Activations</ToggleButton>
                    <ToggleButton value="events">Events</ToggleButton>
                </ToggleButtonGroup>
            </div>

            {isError && (
                <div className={styles.errorMessage}>
                    Unable to load events data. The events service may not be
                    available.
                </div>
            )}

            {view === 'schedule' && (
                <ScheduleView initialEventId={initialEventId} />
            )}
            {view === 'activations' && <ActivationsView />}
            {view === 'events' && (
                <EventsView
                    onOpenSchedule={(eventId) => {
                        setInitialEventId(eventId);
                        setView('schedule');
                    }}
                />
            )}
        </Section>
    );
}
